/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** UpdateAuthResetResponse — dark-roast DTO: AuthResponseDto; also used by updateAuthTokenLogin, createAuth, createAuthRefreshToken */
export const updateAuthResetResponseSchema = z.object({ "data": z.string().nullish() });
export type UpdateAuthResetResponse = z.infer<typeof updateAuthResetResponseSchema>;
